import React from "react";
import { useChangeBackground } from "../hooks/useChangeBackground";
import useVerifyMenu from "../hooks/useVerifyMenu";
import { Helmet } from "react-helmet";
import { useHistory } from "react-router-dom";
import AdminMui from "../components/Masters/AdminMui";
import { useChangeTitleAppBar } from "../hooks/useChangeTitleAppBar";
import {
  ListArranque,
  UpdateArranque,
  CreateArranque,
} from "../utils/Arranque";
import Swal from "sweetalert2";
import ArranqueTable from "../components/Organisms/Arranque/ArranqueTable";
import EditArranque from "../components/Organisms/Arranque/EditArranque";

const Arranque = () => {
  const back = useVerifyMenu();
  const history = useHistory();
  const [arranque_json, setArranque_Json] = React.useState([]); // Cargar los datos
  const [againFetch, setAgainFetch] = React.useState(false);
  const [showModal, setShowMondal] = React.useState({
    show: false,
    data: {},
  });

  useChangeBackground("#f5f5f8");
  useChangeTitleAppBar("Configuración arranque");

  React.useEffect(() => {
    ListArranque()
      .then((res) => setArranque_Json(res.data))
      .catch((err) =>
        Swal.fire({
          title: "Error!",
          text: err.message || "",
          icon: "error",
          confirmButtonText: "Ok",
        })
      );
  }, [againFetch]);

  const ApiDeleteArranque = (arranque) => {
    return UpdateArranque(arranque);
  };

  const handleClick = (suspension_name) => {
    if (!suspension_name.id) {
      CreateArranque(suspension_name)
        .then((res) => {
          setShowMondal({
            show: false,
            data: {},
          });
          Swal.fire({
            title: "Proceso Ejecutado exitosamente!",
            text: res.message || "",
            icon: "success",
            confirmButtonText: "Ok",
          }).then(() => setAgainFetch(!againFetch));
        })
        .catch((err) => {
          setShowMondal({
            show: false,
            data: {},
          });
          Swal.fire({
            title: "Error!",
            text: err || "",
            icon: "error",
            confirmButtonText: "Ok",
          });
        });
    } else {
      UpdateArranque(suspension_name)
        .then((res) => {
          setShowMondal({
            show: false,
            data: {},
          });
          Swal.fire({
            title: "Proceso Ejecutado exitosamente!",
            text: res.message || "",
            icon: "success",
            confirmButtonText: "Ok",
          }).then(() => setAgainFetch(!againFetch));
        })
        .catch((err) => {
          setShowMondal({
            show: false,
            data: {},
          });
          Swal.fire({
            title: "Error!",
            text: err.message || "",
            icon: "error",
            confirmButtonText: "Ok",
          });
        });
    }
  };

  return !back ? (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Configuración de arranque - Supre</title>
        <meta name="description" content="Tipo de arranque - admin supre" />
      </Helmet>
      <AdminMui>
        <ArranqueTable
          arranque_json={arranque_json}
          ApiDeleteArranque={ApiDeleteArranque}
          setAgainFetch={setAgainFetch}
          setShowMondal={setShowMondal}
          againFetch={againFetch}
        />
        {showModal.show && (
          <EditArranque
            showModal={showModal}
            setShowMondal={setShowMondal}
            handleClick={handleClick}
          />
        )}
      </AdminMui>
    </>
  ) : (
    <>{history.push("/admin/login")}</>
  );
};

export default Arranque;
